import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    NOTIFICATION
} from "./type";


export const getNotification = (page=1, limit=0) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.notification}?page=${page}&limit=${limit}`,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: NOTIFICATION,
            payload: data.response.data,
        });
        return true;
    }
};